import Divider from '@mui/material/Divider';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ListItem from '@mui/material/ListItem';
import Avatar from '@mui/material/Avatar';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import { TCustomTheme } from '@mgm/common/theme';
import { useCustomTheme } from '@mgm/common/hooks/useCustomTheme';
import { BaseDrawer, BaseDrawerTitle } from '@mgm/common/components/base';
import { useAppDispatch, useAppSelector } from '../hooks/useAppStore';
import { commonActions } from '../store/common/slice';
import { getIsOpenReleaseNav } from '../store/common/selectors';

const DOR_DATA = [
  'Hourly Visitor Analytics: Track the number of customers visiting your store every hour.',
  'Total Sales Insights: View real-time sales performance to understand peak hours and revenue trends.',
  'Employee Sales Contribution: See detailed breakdowns of sales made by individual employees.',
  'Performance Optimization: Leverage combined foot traffic and sales data to make data-driven decisions.',
  'Enhanced Store Insights: Gain a comprehensive understanding of your store’s activity for better planning and execution.',
];

const BULK_UPLOAD_DATA = [
  'Bulk Team Member Upload: Simplify team management by uploading multiple team members at once using our CSV bulk upload feature. Ensure all necessary details like name, email, and permission levels are included.',
  'Error Detection & Validation: The bulk upload feature automatically detects duplicate emails and invalid permission levels, ensuring data accuracy and integrity before submission.',
  'Streamlined Onboarding: Easily onboard your entire team with just a few clicks, saving time and reducing manual data entry errors.',
];

const ReleaseNav = () => {
  const dispatch = useAppDispatch();
  const theme = useTheme() as TCustomTheme;
  const { isMobile } = useCustomTheme(theme);
  const isOpenReleaseNav = useAppSelector(getIsOpenReleaseNav);

  const closeNavigation = () => {
    dispatch(commonActions.setIsOpenReleaseNav(false));
  };

  const onCloseDrawer = () => {
    dispatch(commonActions.setToggleDrawer(false));
  };

  return (
    <BaseDrawer
      open={isOpenReleaseNav}
      drawerProps={{
        anchor: 'right',
        width: isMobile ? 'auto' : 600,
        variant: 'persistent',
      }}
      onCloseDrawer={onCloseDrawer}
    >
      <BaseDrawerTitle
        title="Unlock New Possibilities with ManageMate's Latest Features"
        handleClose={closeNavigation}
      />
      <Divider sx={{ borderStyle: 'dashed' }} />
      <Box p={4}>
        <Typography pb={2} px={5} textAlign="center" variant="h6">
          Revolutionize Store Insights with DOR Integration
          Discover Hourly Visitor Analytics and Sales Performance
        </Typography>
        {DOR_DATA.map((item) => (
          <Box key={item} component={ListItem} disableGutters width="auto" padding={0}>
            <Box
              component={ListItemAvatar}
              minWidth="auto !important"
              marginRight={2}
            >
              <Box
                component={Avatar}
                bgcolor={theme.palette.primary.main}
                width={20}
                height={20}
                sx={{
                  color: 'white',
                }}
              >
                <svg
                  width={12}
                  height={12}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </Box>
            </Box>
            <ListItemText
              primary={item}
              primaryTypographyProps={{
                variant: 'body2',
              }}
            />
          </Box>
        ))}
        <Box py={4}>
          <img src="/static/dorApp.png" alt="dorApp" />
        </Box>
        <Typography pb={2} px={5} textAlign="center" variant="h6">
          Simplify Team Management with Bulk Upload
        </Typography>
        {BULK_UPLOAD_DATA.map((item) => (
          <Box key={item} component={ListItem} disableGutters width="auto" padding={0}>
            <Box
              component={ListItemAvatar}
              minWidth="auto !important"
              marginRight={2}
            >
              <Box
                component={Avatar}
                bgcolor={theme.palette.primary.main}
                width={20}
                height={20}
                sx={{
                  color: 'white',
                }}
              >
                <svg
                  width={12}
                  height={12}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </Box>
            </Box>
            <ListItemText
              primary={item}
              primaryTypographyProps={{
                variant: 'body2',
              }}
            />
          </Box>
        ))}
        <Box py={4}>
          <img src="/static/bulk.png" alt="bulk" />
        </Box>
      </Box>
    </BaseDrawer>
  );
};

export {
  ReleaseNav,
};
